export const hover = (content: string): string => `
  @media (hover: hover) {
    &:hover {
      ${content};
    }
  }
`;
